const initialState = {
  assetTags: [],
};

export default initialState;
